export default __webpack_public_path__ + "0f97c3b97c96323c6f149a01b1b31ade.png";